var map = {
	"./Bookcases/images/subImgs/LibATerraHome.svg": 7646,
	"./Bookcases/images/subImgs/LibATerraPublic.svg": 4657,
	"./Bookcases/images/subImgs/LibPonte.svg": 6128,
	"./Bookcases/images/subImgs/LibSospeseHome.svg": 5616,
	"./Bookcases/images/subImgs/LibSospesePublic.svg": 3796,
	"./Bookcases/images/subImgs/LibSovrapposte.svg": 9332,
	"./Storageunits/images/subImgs/ATerraHome.svg": 1371,
	"./Storageunits/images/subImgs/ATerraPublic.svg": 9417,
	"./Storageunits/images/subImgs/PensiliHome.svg": 4571,
	"./Storageunits/images/subImgs/PensiliPublic.svg": 243,
	"./Storageunits/images/subImgs/SospeseHome.svg": 3464,
	"./Storageunits/images/subImgs/SospesePublic.svg": 1473,
	"./Unikosystem/images/subImgs/UnikoHome.svg": 5229,
	"./Unikosystem/images/subImgs/UnikoPublic.svg": 1454,
	"./Walkinclosets/images/subImgs/CabinaHome.svg": 5883,
	"./Walkinclosets/images/subImgs/CremaHome.svg": 2907,
	"./Walkinclosets/images/subImgs/CremaPublic.svg": 2784,
	"./Walkinclosets/images/subImgs/SpallaHome.svg": 6500,
	"./Walkinclosets/images/subImgs/SpallaPublic.svg": 180,
	"./Wallpanelling/images/subImgs/ArnadHome.svg": 9349,
	"./Wallpanelling/images/subImgs/ArnadPublic.svg": 7373,
	"./Wallpanelling/images/subImgs/CoverHome.svg": 5251,
	"./Wallpanelling/images/subImgs/CoverPublic.svg": 7402,
	"./Wardrobes/images/subImgs/AntaBattenteHome.svg": 1978,
	"./Wardrobes/images/subImgs/AntaBattentePublic.svg": 5834,
	"./Wardrobes/images/subImgs/BasiHome.svg": 8427,
	"./Wardrobes/images/subImgs/BasiPublic.svg": 7075,
	"./Wardrobes/images/subImgs/PontiHome.svg": 6955,
	"./Wardrobes/images/subImgs/PontiPublic.svg": 6923,
	"./Wardrobes/images/subImgs/ScorrevoleHome.svg": 4802,
	"./Wardrobes/images/subImgs/ScorrevolePublic.svg": 7879,
	"./Wardrobes/images/subImgs/ServiceHome.svg": 4297,
	"./Wardrobes/images/subImgs/ServicePublic.svg": 628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2389;